"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultUpsertGeoObjectInput = exports.defaultUpsertArticleInput = void 0;
const types_1 = require("../types");
exports.defaultUpsertArticleInput = {
    Id: undefined,
    Type: types_1.EArticleType.News,
    Header: "",
    Body: "",
    Important: false,
    AttachmentId: undefined,
    PushText: undefined,
    RegionId: undefined,
};
exports.defaultUpsertGeoObjectInput = {
    Id: undefined,
    Type: types_1.EGeoObjectType.Containers,
    Status: types_1.EGeoObjectStatus.New,
    Lat: 0,
    Long: 0,
    Address: "",
    AllTime: true,
    Containers: 0,
    SpecialContainers: 0,
    AttachmentId: undefined,
    RegionName: "",
};
//# sourceMappingURL=constants.js.map